module.exports = __webpack_public_path__ + "img/hot.859b2d4c.png";